import { jsxs as v, jsx as c } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M43.897 24.338c1.54 1.131 3.606 1.805 5.525 1.805 1.919 0 4.014-.648 5.523-1.734 1.354-.974 2.97-2.796 2.97-5.939 0-2.296-1.404-5.056-4.172-8.203-2.042-2.32-4.113-4.004-4.133-4.021l-.19-.155-.19.158c-.02.017-2.09 1.747-4.13 4.089-2.767 3.177-4.17 5.912-4.17 8.132 0 3.05 1.613 4.875 2.967 5.869Zm8.278-12.69c1.105 1.256 1.98 2.455 2.597 3.56.699 1.252 1.053 2.349 1.053 3.262 0 1.813-.708 3.24-2.101 4.243a7.002 7.002 0 0 1-2.12 1.015 7.836 7.836 0 0 1-2.182.326 7.281 7.281 0 0 1-2.158-.345 7.285 7.285 0 0 1-2.132-1.056c-.656-.481-1.167-1.054-1.52-1.704-.394-.725-.593-1.56-.593-2.48 0-.865.35-1.93 1.042-3.164.615-1.098 1.486-2.299 2.589-3.567a39.145 39.145 0 0 1 2.787-2.873c.726.665 1.735 1.64 2.739 2.781l-.001.002Z"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "m50.753 21.907-.435-1.95-.01.002a2.076 2.076 0 0 0 1.549-2.03l1.997.055c-.07 2.572-2.059 3.69-3.1 3.923Z"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M56.111 26.03c-.658.474-1.402.878-2.193 1.202v7.336H51.89v-6.703c-.82.18-1.653.276-2.47.276-.504 0-1.014-.04-1.526-.114v3.67h-5.442a3.496 3.496 0 0 0-3.496 3.495v5.656c0 7.131-5.716 13.025-12.848 13.066-7.16.04-13-5.772-13-12.924V16.069h5.645v24.828c0 4.008 3.2 7.334 7.208 7.373 4.046.039 7.351-3.242 7.351-7.28v-8.938a6 6 0 0 1 6-6h3.548c-.049-.035-.099-.068-.147-.103-1.414-1.038-2.46-2.368-3.088-3.893h-.311c-5.521 0-9.996 4.475-9.996 9.996v8.872c0 1.838-1.503 3.38-3.341 3.35a3.287 3.287 0 0 1-3.228-3.285V16.068h3.077V6.15H6.086v9.918h3.03v24.757c0 9.353 7.518 17.057 16.87 17.083 9.352.026 16.968-7.573 16.968-16.919v-5.3h4.942v2.874h10.018V24.332a9.3 9.3 0 0 1-1.802 1.699Zm-46.03-15.884h11.75v1.927h-11.75v-1.927Z"
        }
      )
    ]
  }
);
export {
  r as WaterSupplyPipe
};
